//See examples of linktext and text properties at Planning (Menu) and Editon Invoicing (Submenu)

import React from 'react';
import Timesheet from './Contents/TimeSheet/timeSheet';
import ManageTasks from './Contents/TimeSheet/manageTasks';
import ExportComponent from './Contents/TimeSheet/export';
import HomeRoot from './Contents/Home/HomeRoot';
import FreelancerFeeAdmin from './Contents/FreelancerInvoicing/FreelancerFees/FreelancerFeeAdmin';
import FreelancerUserAdmin from './Contents/FreelancerInvoicing/FreelancerUserAdmin/FreelancerUserAdmin';
import FpaAdmin from './Contents/FreelancerInvoicing/FreelancerPayableAssignments/FpaAdmin';
import LeadAdmin from './Contents/Sales/LeadAdmin/LeadAdmin';
import DashboardAdmin from './Contents/Administration/Dashboard/DashboardAdmin';
import UserAdmin from './Contents/User/UserAdmin/UserAdmin';
import OfficeAdmin from './Contents/Office/OfficeAdmin/OfficeAdmin';
import FreelancerLineItemAdmin from './Contents/FreelancerInvoicing/FreelancerLineItem/FreelancerLineItemAdmin';
import FreelancerInvoiceAdmin from './Contents/FreelancerInvoicing/FreelancerInvoices/FreelancerInvoiceAdmin';
import OfficeGeneralAdmin from './Contents/Office/OfficeGeneral/OfficeGeneralAdmin';
import FreelancerPaymentExportAdmin from './Contents/FreelancerInvoicing/FreelancerPaymentExport/FreelancerPaymentExportAdmin';
import CurrencyAdmin from './Contents/Currency/CurrencyAdmin/CurrencyAdmin';
import CountryAdmin from './Contents/Countries/CountryAdmin/CountryAdmin';
import ContactAdmin from './Contents/Sales/ContactAdmin/ContactAdmin';
import LocationsAdmin from './Contents/Operations/Locations/LocationsAdmin';
import LookupAdminPanel from './Contents/Administration/Lookup/LookupAdminPanel';
import ImportShopAdmin from './Contents/RoverImport/ImportShopAdmin/ImportShopAdmin';
import ApolloDataExportAdmin from './Contents/RoverImport/ApolloDataExportAdmin/ApolloDataExportAdmin';
import ClientAdmin from './Contents/Sales/ClientAdmin/ClientAdmin';
import OpportunityAdmin from './Contents/Sales/OpportunityAdmin/OpportunityAdmin';
import CaspianXXQueryProcessingHistoryAdmin from './Contents/RoverImport/CaspianXXQueryProcessingHistoryAdmin/CaspianXXQueryProcessingHistoryAdmin';
import ApolloCustomTriggerAdmin from './Contents/RoverImport/ApolloCustomTriggerAdmin/ApolloCustomTriggerAdmin';
import ApolloShopCopierAdmin from './Contents/RoverImport/ApolloShopCopier/ApolloShopCopierAdmin';
import SurveyTransferMappingAdmin from './Contents/RoverImport/SurveyTransferMappingAdmin/SurveyTransferMappingAdmin';
import ReportAdmin from './Contents/Operations/Reports/ReportAdmin';
import PlanningMain from './Contents/Planning/PlanningMain';
import ProjectAdmin from './Contents/Operations/Projects/ProjectAdmin';
import PaymentExportAdmin from './Contents/Operations/PaymentExport/PaymentExportAdmin';
import TestComponentForUrlBasedPages from './Elements/TestComponentForUrlBasedPages';
import PaymentExportDetails from './Contents/Operations/PaymentExport/AllExport/PaymentExportDetails';
import ServiceItemAdmin from './Contents/Sales/ServiceAdmin/ServiceItemAdmin';
import PricingAdmin from './Contents/Sales/PricingAdmin/PricingAdmin.jsx';
import PricingDetailAdmin from './Contents/Sales/PricingDetail/PricingDetailAdmin.jsx';
import PlanningList from './Contents/Planning/PlanningItem/PlanningList.js';
import PlanningDetailList from './Contents/Planning/PlanningDetail/PlanningDetailList.js';
import RefExample from './Experiment/RefExample/RefExample.js';
import Messages from './Contents/Messages/Messages.js';
import Downloads from './Contents/Downloads/Downloads.js';
import IobAdmin from './Contents/Operations/IOB/IobAdmin.js';
import IobDetails from './Contents/Operations/IOB/IobDetails.js';
import SurveyTransferQuestionRulesDetails from './Contents/RoverImport/SurveyTransferMappingAdmin/SurveyTransferQuestionRulesDetails.tsx';
import SurveyTransferAnswerOptionRulesDetails from './Contents/RoverImport/SurveyTransferMappingAdmin/SurveyTransferAnswerOptionRulesDetails.tsx';
import DesignSystemPage from './Contents/DesignSystem/DesignSystemPage.tsx';
import CreditMemoParentAdmin from './Contents/Operations/CreditMemo/CreditMemoParentAdmin.js';
import CreditMemoDetails from './Contents/Operations/CreditMemo/CreditMemoDetails.js';
import CreditMemoRequestDetails from './Contents/Operations/CreditMemo/CreditMemoRequestDetails.js';
import Profile from './Contents/User/UserAdmin/Profile.js';
import ClientLineItemDetails from './Contents/Operations/CreditMemo/ClientLineItemDetails.js';
import BambooHrApiLogAdmin from './Contents/LogAdmins/ApiLogAdmin/BambooHrApiLogAdmin.js';
import AssignmentPaymentsParentAdmin from './Contents/Operations/AssignmentPayments/AssignmentPaymentsParentAdmin.jsx';
import AssignmentPaymentDetails from './Contents/Evaluator/EvaluatorAdmin/EvaluatorPayments/AssignmentPaymentDetails.js';
import ClientInvoiceAdmin from './Contents/Operations/ClientInvoiceAdmin/ClientInvoiceAdmin.js';
import AntiFraudToolAdmin from './Contents/Operations/AntiFraudTool/AntiFraudToolAdmin.js';
import FraudHitDetails from './Contents/Operations/AntiFraudTool/FraudHitDetails.js';
import ClientInvoiceDetails from './Contents/Operations/ClientInvoiceAdmin/Details/ClientInvoiceDetails.js';
import ServiceDetails from './Contents/Sales/ServiceAdmin/ServiceDetails.js';
import PricingItemDetails from './Contents/Sales/PricingAdmin/PricingItemDetails.js';
import AvailabilityPlanner from './Contents/TimeSheet/AvailabilityPlanner/AvailabilityPlannerAdmin.js';
import OfficeCalendar from './Contents/TimeSheet/AvailabilityPlanner/OfficeCalendarAdmin.js';
import ClientPaymentParentAdmin from './Contents/Finance/ClientPayment/ClientPaymentParentAdmin.js';
import ClientPaymentDetails from './Contents/Finance/ClientPayment/ClientPaymentDetails.js';
import EvaluatorParentAdmin from './Contents/Evaluator/EvaluatorAdmin/EvaluatorParentAdmin.js';
import ClientPrePaymentDetails from './Contents/Finance/ClientPrePayment/ClientPrePaymentDetails.js';
import AssignmentParentAdmin from './Contents/Operations/Assignments/AssignmentParentAdmin.js';
import AssignmentDetails from './Elements/Reports/GeneralFinanceReports/AssignmentDetails';
import GeneralFinanceReportsAdmin from './Elements/Reports/GeneralFinanceReports/GeneralFinanceReportsAdmin';
import UnbilledAR from './Elements/Reports/GeneralFinanceReports/UnbilledAR';
import AssignmentDetailsLite from './Elements/Reports/GeneralFinanceReports/AssignmentDetailsLite';
import ClientAssignmentRevenueExpenses from './Elements/Reports/GeneralFinanceReports/ClientAssignmentRevenueExpenses';
import ProjectAssignmentRevenueExpenses from './Elements/Reports/GeneralFinanceReports/ProjectAssignmentRevenueExpenses';
import VoidAndReissued from './Elements/Reports/GeneralFinanceReports/VoidAndReissued';
import OperationalSubledgerSummary from './Elements/Reports/GeneralFinanceReports/OperationalSubledgerSummary';
import OperationalSubledgerDetail from './Elements/Reports/GeneralFinanceReports/OperationalSubledgerDetail';
import ClientDepositDetails from './Elements/Reports/GeneralFinanceReports/ClientDepositDetail';
import PrepayLineItemsAR from './Elements/Reports/GeneralFinanceReports/PrepayLineItemsAr';
import LineItemsAr from './Elements/Reports/GeneralFinanceReports/LineItemsAr';
import CreditMemosAr from './Elements/Reports/GeneralFinanceReports/CreditMemosAr';
import PrepayCreditMemosAr from './Elements/Reports/GeneralFinanceReports/PrepayCreditMemosAr';
import IobList from './Elements/Reports/GeneralFinanceReports/IobList';
import ClientAdjustedGrossRevenue from './Elements/Reports/GeneralFinanceReports/ClientAdjustedGrossRevenue';
import CorporateOfficeFinanceReportsAdmin from './Elements/Reports/CorporateOfficeFinanceReports/CorporateOfficeFinanceReportsAdmin';
import IobSummary from './Elements/Reports/CorporateOfficeFinanceReports/IobSummary';
import TaxReport from './Elements/Reports/CorporateOfficeFinanceReports/TaxReport';
import EvaluatorPaymentRecReport from './Elements/Reports/CorporateOfficeFinanceReports/EvaluatorPaymentRecReport';
import RevenueMetricsReportsAdmin from './Elements/Reports/RevenueMetricsReports/RevenueMetricsReportsAdmin';
import AssignmentFeeRevenueByIndustry from './Elements/Reports/RevenueMetricsReports/AssignmentFeeRevenueByIndustry';
import AssignmentFeeRevenueByService from './Elements/Reports/RevenueMetricsReports/AssignmentFeeRevenueByService';
import LineItemFeeRevenueByIndustry from './Elements/Reports/RevenueMetricsReports/LineItemFeeRevenueByIndustry';
import LineItemFeeRevenueByType from './Elements/Reports/RevenueMetricsReports/LineItemFeeRevenueByType';
import AssignmentLineItemFeeRevenueByIndustry from './Elements/Reports/RevenueMetricsReports/AssignmentLineItemFeeRevenueByIndustry';
import EvaluatorExpenseAnalysisReport from './Elements/Reports/GeneralFinanceReports/EvaluatorExpensesAnalysisReport.js';
import JournalEntriesReport from './Elements/Reports/GeneralFinanceReports/JournalEntriesReport.js';
import OfficeGrossProfitReport from './Elements/Reports/GeneralFinanceReports/OfficeGrossProfitReport.js';
import TpLocationAdmin from './Contents/ThirdParty/TpLocation/TpLocationAdmin.js';
import TpClientLinkAdmin from './Contents/ThirdParty/TpClientLink/TpClientLinkAdmin.js';
import TpJobAdmin from './Contents/Operations/TpJob/TpJobAdmin.js';
import NewProjectAdmin from './Contents/ThirdParty/Project/NewProjectAdmin.js';
import DomoReportTest from './Contents/Testing/DomoReportTest.js';
import BiTestReports from './Contents/Testing/BiTestReports.tsx';
import TpClientInvoiceAdmin from './Contents/Operations/TpClientInvoice/TpClientInvoiceAdmin.js';
import TpClientInvoiceDetails from './Contents/Operations/TpClientInvoice/Details/TpClientInvoiceDetails.js';
import CommissionLineParentAdmin from './Contents/Sales/CommissionLine/CommissionLineParentAdmin.js';
import TpEvaluatorTpJobPaymentsAdmin from './Contents/ThirdParty/TpEvaluatorTpJobPayments/TpEvaluatorTpJobPaymentsAdmin.js';
import TpDataExportExcludedItemAdmin from './Contents/ThirdParty/TpDataExportExcludedItem/TpDataExportExcludedItemAdmin.js';
import TpDataImportExcludedItemAdmin from './Contents/ThirdParty/TpDataImportExcludedItem/TpDataImportExcludedItemAdmin.tsx';
import TpPlatformInvoiceAdmin from './Contents/Operations/TpPlatformInvoice/TpPlatformInvoiceAdmin.tsx';
import TpClientPaymentParentAdmin from './Contents/ThirdParty/TpClientPayment/TpClientPaymentParentAdmin.jsx';
import TpClientPaymentDetails from './Contents/ThirdParty/TpClientPayment/TpClientPaymentDetails.js';
import TpEvaluatorParentAdmin from './Contents/ThirdParty/TpEvaluator/TpEvaluatorParentAdmin.js';
import TpCreditMemoAdmin from './Contents/Operations/TpCreditMemo/TpCreditMemoAdmin.js';
import TpCreditMemoDetails from './Contents/Operations/TpCreditMemo/Details/TpCreditMemoDetails.js';
import TpClientInvoiceLineItemDetails from './Contents/Operations/TpCreditMemo/Details/TpClientInvoiceLineItemDetails.js';
import TpRealtedClientPrePaymentDetails from './Contents/ThirdParty/TpClientPayment/ClientPrePayment/TpRealtedClientPrePaymentDetails.js';
import TpClientPrePaymentDetails from './Contents/ThirdParty/TpClientPayment/ClientPrePayment/TpClientPrePaymentDetails.js';
import UrlShortenerAdmin from './Contents/UrlShortenerAdmin/UrlShortenerAdmin.js';
import AiChatAdmin from './Contents/ToolsMenu/AiChat/AiChatAdmin.jsx';
import FinanceReportsAdmin from './Elements/Reports/GeneralFinanceReports/FinanceReportsAdmin.js';
import ArAgeingReport from './Elements/Reports/IFrameReports/ArAgeingReport.js';
import SystemAlertAdmin from './Contents/SystemAlertAdmin/SystemAlertAdmin.js';
import TpAssignmentDetails from './Elements/Reports/GeneralFinanceReports/TpAssignmentDetails.js';
import EndOfMonthAdmin from './Contents/EndOfMonth/EndOfMonthAdmin.jsx';
import GroupAdmin from './Contents/Administration/UserGroups/GroupAdmin.jsx';
import ShopCountReport from './Elements/Reports/IFrameReports/ShopCountReport.js';
import OpsPBIDashboard from './Elements/Reports/IFrameReports/OpsPBIDashboard.js';
import DqTatReport from './Elements/Reports/IFrameReports/DqTatReport.tsx';
import VendorDomoReport from './Contents/FreelancerInvoicing/VendorDashboard/VendorDomoReport';
import FteTrackingAdmin from './Contents/FteTracking/FteTrackingAdmin.jsx';

// prettier-ignore
const menuitems = [
  {
    text: 'CRM',
    link: 'homelink',
    icon: 'fa-solid fa-cloud',
    key: 'user_key',
    url: 'home',
    file: 'Contents/Home/Home.tsx',
    submenu: [
      {
        text: 'Home',
        link: <HomeRoot />,
        icon: 'fa fa-igloo',
        key: 'user_key',
        url: 'home',
        file: 'Contents/Home/Home.tsx',
      },
      {
        text: 'User',
        link: <UserAdmin />,
        icon: 'fa fa-user',
        key: 'user_key',
        url: 'home_users',
        file: 'Contents/User/UserAdmin/UserAdmin.js',
      },
      {
        text: 'Offices',
        link: <OfficeAdmin />,
        icon: 'fa fa-building',
        key: 'user_key',
        url: 'home_offices',
        file: 'Contents/Office/OfficeAdmin/OfficeAdmin.js',
      },
      {
        text: 'Office General',
        link: <OfficeGeneralAdmin />,
        icon: 'fa-solid fa-globe',
        key: 'home_general',
        url: 'home_general',
        file: 'Contents/Office/OfficeGeneral/OfficeGeneralAdmin.tsx',
      },
      {
        text: 'Countries',
        link: <CountryAdmin />,
        icon: 'fa-solid fa-globe-americas',
        key: 'user_key',
        url: 'home_countries',
        file: 'Contents/Countries/CountryAdmin/CountryAdmin.js',
      },
      {
        text: 'Currency',
        link: <CurrencyAdmin />,
        icon: 'fa-solid fa-coins',
        key: 'user_key',
        url: 'home_currency',
        file: 'Contents/Currency/CurrencyAdmin/CurrencyAdmin.js',
      },
      {
        text: 'System Alerts',
        link: <SystemAlertAdmin />,
        icon: 'fa-solid fa-bell',
        key: 'JustAdmins',
        url: 'systemalerts',
        file: 'Contents/SystemAlertAdmin/SystemAlertAdmin.js',
      },
      {
        text: 'End of Month',
        link: <EndOfMonthAdmin />,
        icon: 'fa fa-calendar-check',
        key: 'end_of_month',
        url: 'end_of_month',
        file: 'Contents/EndOfMonth/EndOfMonthAdmin.jsx',
      },
      {
        text: 'User Groups',
        link: <GroupAdmin />,
        icon: 'fa fa-users-cog',
        key: 'user_groups',
        url: 'user_groups',
        file: 'Contents/Administration/UserGroups/GroupAdmin.jsx',
      }
    ],
  },
  {
    text: 'Sales',
    link: <LeadAdmin />,
    icon: 'fa-solid fa-bullhorn',
    key: 'sales',
    url: 'sales',
    file: 'Contents/Sales/PricingDetail/PricingDetailAdmin.jsx',
    submenu: [
      {
        text: 'Leads',
        link: <LeadAdmin />,
        icon: 'fa-solid fa-funnel-dollar',
        key: 'sales_leads',
        url: 'sales',
        file: 'Contents/Sales/LeadAdmin/LeadAdmin.js',
      },
      {
        text: 'Clients',
        link: <ClientAdmin />,
        icon: 'fa fa-coffee',
        key: 'sales_clients',
        url: 'sales_clients',
        file: 'Contents/Sales/ClientAdmin/ClientAdmin.js',
      },
      {
        text: 'Contacts',
        link: <ContactAdmin />,
        icon: 'fa-regular fa-address-book',
        key: 'sales_clientcontacts',
        url: 'sales',
        file: 'Contents/Sales/ContactAdmin/ContactAdmin.js',
      },
      {
        text: 'Opportunities',
        link: <OpportunityAdmin />,
        icon: 'fa-solid fa-square-poll-vertical',
        key: 'sales_opportunities',
        url: 'sales_opportunities',
        file: 'Contents/Sales/OpportunityAdmin/OpportunityAdmin.js',
      },
      {
        text: 'Services',
        link: <ServiceItemAdmin />,
        icon: 'fa-regular fa-address-book',
        key: 'sales_opportunities',
        url: 'sales_service',
        file: 'Contents/Sales/ServiceAdmin/ServiceItemAdmin.tsx',
      },
      {
        text: 'Commission Line',
        link: <CommissionLineParentAdmin />,
        icon: 'fa-solid fa-hand-holding-dollar',
        key: 'user_key',
        url: 'sales_commissionlines',
        file: 'Contents/Sales/CommissionLine/CommissionLineParentAdmin.js',
      },
      //{text:"Pricing",link:<PricingMain  ServiceId={ 13293}/>,icon:"fa-regular fa-address-book", key:"sales_contacts", url:"sales_contacts", file:"Contents/Sales/ContactAdmin/ContactAdmin.js"},
    ],
  },
  {
    text: 'Operations',
    link: 'operations',
    icon: 'fa fa-gopuram',
    key: 'user_key',
    url: 'operations',
    file: 'Contents/Planning/PlanningMain.js',
    submenu: [
      {
        text: 'Planning',
        link: <PlanningMain />,
        icon: 'fa fa-ruler-combined',
        key: 'user_key',
        url: 'planning',
        file: 'Contents/Planning/PlanningMain.js',
      },
      {
        text: 'Locations',
        link: <LocationsAdmin />,
        icon: 'fa-solid fa-location-dot',
        key: 'operations_location',
        url: 'locations',
        file: 'Contents/Operations/Locations/LocationsAdmin.js',
      },
      {
        text: 'Apollo Shop Copier',
        linktext: 'Apollo Shop Copier',
        link: <ApolloShopCopierAdmin />,
        icon: 'fa-solid fa-clone',
        key: 'apolloshopcopier',
        url: 'ApolloShopCopierAdmin',
        file: 'Contents/RoverImport/ApolloShopCopier/ApolloShopCopierAdmin.js',
      },
      {
        text: 'Assignments',
        link: <AssignmentParentAdmin />,
        icon: 'fa-solid fa-clipboard-list',
        key: 'operations_assignments',
        url: 'assignments',
        file: 'Contents/Operations/Assignments/AssignmentParentAdmin.js',
      },
      {
        text: 'Projects',
        link: <ProjectAdmin />,
        icon: 'fa-solid fa-link-simple',
        key: 'operations_projects',
        url: 'projects',
        file: 'Contents/Operations/Projects/ProjectAdmin.js',
      },
      {
        text: 'Payment Exports',
        linktext: 'Payment Exports',
        link: <PaymentExportAdmin />,
        icon: 'fa-solid fa-clone',
        key: 'operations_paymentexports',
        url: 'PaymentExport',
        file: 'Contents/Operations/PaymentExport/PaymentExportAdmin.js',
      },
      {
        text: 'Credit Memos',
        link: <CreditMemoParentAdmin />,
        icon: 'fa-solid fa-credit-card',
        key: 'operations_creditmemos',
        url: 'creditmemo',
        file: 'Contents/Operations/CreditMemo/CreditMemoParentAdmin.js',
      },
      {
        text: 'Assignment Payments',
        link: <AssignmentPaymentsParentAdmin />,
        icon: 'fa-solid fa-credit-card',
        key: 'operations_evaluatorpayments',
        url: 'assignmentpayments',
        file: 'Contents/Operations/AssignmentPayments/AssignmentPaymentsParentAdmin.jsx',
      },
      {
        text: 'IOB',
        link: <IobAdmin />,
        icon: 'fa-solid fa-link-simple',
        key: 'operations_iob',
        url: 'iob',
        file: 'Contents/Operations/IOB/IobAdmin.js',
      },
      {
        text: 'Evaluator Admin',
        linktext: 'Evaluators',
        link: <EvaluatorParentAdmin />,
        icon: 'fa-solid fa-chart-line',
        key: 'evaluator_admin',
        url: 'evaluator',
        file: 'Contents/Evaluator/EvaluatorAdmin/EvaluatorParentAdmin.js',
      },
      {
        text: 'Client Invoices',
        linktext: 'Invoices',
        link: <ClientInvoiceAdmin />,
        icon: 'fa-solid fa-file-invoice-dollar',
        key: 'operations_invoices_admin',
        url: 'operations_invoices',
        file: 'Contents/Operations/ClientInvoiceAdmin/ClientInvoiceAdmin.js',
      },
      {
        text: 'Anti-Fraud Tool',
        link: <AntiFraudToolAdmin />,
        icon: 'fa-solid fa-alien-8bit',
        key: 'operations_antifraudtool',
        url: 'antifraudtool',
        file: 'Contents/Operations/AntiFraudTool/AntiFraudToolAdmin.js',
      },
    ],
  },
  {
    text: 'TP Operations',
    link: 'tpoperations',
    icon: 'fa fa-user-nurse',
    key: 'user_key',
    url: 'tpoperations',
    file: 'Contents/Planning/PlanningMain.js',
    submenu: [
      {
        text: 'TP Evaluator',
        link: <TpEvaluatorParentAdmin />,
        icon: 'fa-solid fa-users-viewfinder',
        key: 'operations_thirdpartyevaluator',
        url: 'tpevaluators',
        file: 'Contents/ThirdParty/TpEvaluator/TpEvaluatorParentAdmin.js',
      },
      {
        text: 'TP Jobs',
        link: <TpJobAdmin />,
        icon: 'fa-solid fa-person-digging',
        key: 'operations_thirdpartyjobs',
        url: 'tpjobs',
        file: 'Contents/Operations/TpJob/TpJobAdmin.js',
      },

      {
        text: 'TP Clients',
        link: <TpClientLinkAdmin />,
        icon: 'fa-solid fa-people-arrows',
        key: 'operations_tpclientlink',
        url: 'tpclientlink',
        file: 'Contents/ThirdParty/TpClientLink/TpClientLinkAdmin.js',
      },
      {
        text: 'TpLocation',
        linktext: 'TpLocation',
        link: <TpLocationAdmin />,
        icon: 'fa-solid fa-vial',
        key: 'operations_tplocation',
        url: 'tplocation',
        file: 'Contents/ThirdParty/TpLocation/TpLocationAdmin.js',
      },
      {
        text: 'TP Export Excluded Items',
        link: <TpDataExportExcludedItemAdmin />,
        icon: 'fa-solid fa-door-open',
        key: 'operations_thirdpartydataexportexcludeditems',
        url: 'tpdataexportexcludeditems',
        file: 'Contents/ThirdParty/TpDataExportExcludedItem/TpDataExportExcludedItemAdmin.js',
      },
      {
        text: 'TP Import Excluded Items',
        link: <TpDataImportExcludedItemAdmin />,
        icon: 'fa-solid fa-filter-circle-xmark',
        key: 'operations_thirdpartydataimportexcludeditems',
        url: 'tpdataimportexcludeditems',
        file: 'Contents/ThirdParty/TpDataImportExcludedItem/TpDataImportExcludedItemAdmin.tsx',
      },
      {
        text: 'Third-Party Projects',
        link: <NewProjectAdmin />,
        icon: 'fa-solid fa-link-simple',
        key: 'new_projects',
        url: 'new_projects',
        file: 'Contents/ThirdParty/Project/NewProjectAdmin.js',
      },
      {
        text: 'Third-Party Client Invoices',
        linktext: 'Third-Party Client Invoices',
        link: <TpClientInvoiceAdmin />,
        icon: 'fa-solid fa-file-invoice-dollar',
        key: 'tpclientinvoices_view',
        url: 'operations_tpinvoices',
        file: 'Contents/Operations/TpClientInvoice/TpClientInvoiceAdmin.js',
      },
      {
        text: 'Third-Party Credit Memos',
        link: <TpCreditMemoAdmin />,
        icon: 'fa-solid fa-credit-card',
        key: 'tpcreditmemos_view',
        url: 'tpcreditmemo',
        file: 'Contents/Operations/TpCreditMemo/TpCreditMemoAdmin.js',
      },
      {
        text: 'TP Evaluator TP Job Payments',
        link: <TpEvaluatorTpJobPaymentsAdmin />,
        icon: 'fa-solid fa-credit-card',
        key: 'operations_evaluatorpayments',
        url: 'tpevaluatortpjobpayments',
        file: 'Contents/ThirdParty/TpEvaluatorTpJobPayments/TpEvaluatorTpJobPaymentsAdmin.js',
      },
    ],
  },

  {
    text: 'Finance',
    link: 'finance',
    icon: 'fa-solid fa-pie-chart',
    key: 'finance',
    url: 'finance',
    file: 'Contents/Finance/ClientPayment/ClientPaymentParentAdmin.js',
    submenu: [
      {
        text: 'Client Payments',
        link: <ClientPaymentParentAdmin />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'finance_clientpayment',
        url: 'finance_clientpayment',
        file: 'Contents/Finance/ClientPayment/ClientPaymentParentAdmin.js',
      },
      {
        text: 'Client Payments (New)',
        link: <TpClientPaymentParentAdmin />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'new_finance_clientpayment',
        url: 'new_finance_clientpayment',
        file: 'Contents/ThirdParty/TpClientPayment/TpClientPaymentParentAdmin.jsx',
      },
      {
        text: 'FTE Tracking',
        link: <FteTrackingAdmin />,
        icon: 'fa-solid fa-people-arrows',
        key: 'outsourcedfte_view',
        url: 'finance_ftetracking',
        file: 'Contents/FteTracking/FteTrackingAdmin.jsx',
      },
      {
        text: 'TP Platform Invoices',
        link: <TpPlatformInvoiceAdmin />,
        icon: 'fa-solid fa-file-invoice',
        key: 'operations_tpplatforminvoices',
        url: 'tpplatforminvoices',
        file: 'Contents/Operations/TpPlatformInvoice/TpPlatformInvoiceAdmin.tsx',
      },
    ],
  },
  {
    text: 'Administration',
    link: 'administration',
    icon: 'fa-solid fa-rectangle-list',
    key: 'JustAdmins',
    url: 'administration',
    file: 'Contents/Administration/Dashboard/DashboardAdmin.js',
    submenu: [
      {
        text: 'Dashboard',
        link: <DashboardAdmin />,
        icon: 'fa-solid fa-gauge',
        key: 'JustAdmins',
        url: 'administration',
        file: 'Contents/Administration/Dashboard/DashboardAdmin.js',
      },
      {
        text: 'Lookup',
        link: <LookupAdminPanel />,
        icon: 'fa-solid fa-telescope',
        key: 'JustAdmins',
        url: 'lookup',
        file: 'Contents/Administration/Lookup/LookupAdminPanel.js',
      },
      {
        text: 'Design System',
        link: <DesignSystemPage />,
        icon: 'fa-solid fa-swatchbook',
        key: 'JustAdmins',
        url: 'designsystem',
        file: 'Contents/DesignSystem/DesignSystemPage.tsx',
      },
      {
        text: 'Url Shortener',
        link: <UrlShortenerAdmin />,
        icon: 'fa-solid fa-arrow-down-short-wide',
        key: 'JustAdmins',
        url: 'urlshortener',
        file: 'Contents/UrlShortenerAdmin/UrlShortenerAdmin.js',
      },
    ],
  },
  {
    text: 'Reports',
    link: 'reports',
    icon: 'fa-solid fa-file-chart-column',
    key: 'user_key',
    url: 'reports',
    file: 'Contents/Operations/Reports/ReportAdmin.js',
    submenu: [
      {
        text: 'OPS Reports',
        link: <ReportAdmin />,
        icon: 'fa-solid fa-file-chart-column',
        key: 'user_key',
        url: 'reports',
        file: 'Contents/Operations/Reports/ReportAdmin.js',
      },
      {
        text: 'General Finance Reports',
        link: <GeneralFinanceReportsAdmin />,
        icon: 'fa-solid fa-file-chart-column',
        key: 'finance_reports',
        url: 'generalFinanceReports',
        file: 'Elements/Reports/GeneralFinanceReports/GeneralFinanceReportsAdmin.js',
      },
      {
        text: 'Finance Reports',
        link: <FinanceReportsAdmin />,
        icon: 'fa-solid fa-file-chart-column',
        key: 'finance_reports',
        url: 'financeReports',
        file: 'Elements/Reports/GeneralFinanceReports/FinanceReportsAdmin.js',
      },
      {
        text: 'Corporate Office Finance Rep.',
        link: <CorporateOfficeFinanceReportsAdmin />,
        icon: 'fa-solid fa-file-chart-column',
        key: 'finance_reports',
        url: 'corporateofficefinancereports',
        file: 'Elements/Reports/CorporateOfficeFinanceReports/CorporateOfficeFinanceReportsAdmin.js',
      },
      {
        text: 'Revenue Metrics Reports',
        link: <RevenueMetricsReportsAdmin />,
        icon: 'fa-solid fa-file-chart-column',
        key: 'finance_reports',
        url: 'revenuemetricsreports',
        file: 'Elements/Reports/RevenueMetricsReports/RevenueMetricsReportsAdmin.js',
      },
      {
        text: 'Shop Count Report',
        link: <ShopCountReport />,
        icon: 'fa-solid fa-file-chart-column',
        key: 'reports_shopcountreport',
        url: 'reports_shopcountreport',
        file: 'Elements/Reports/IFrameReports/ShopCountReport.js',
      },
      {
        text: 'Ops PBI Dashboard',
        link: <OpsPBIDashboard />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'reports_opspbidashboard',
        url: 'reports_opspbidashboard',
        file: 'Elements/Reports/IFrameReports/OpsPBIDashboard.js',
      },
      {
        text: 'DQ TAT Report',
        link: <DqTatReport />,
        icon: 'fa-solid fa-file-chart-column',
        key: 'reports_dqtatreport',
        url: 'reports_dqtatreport',
        file: 'Elements/Reports/IFrameReports/DqTatReport.tsx',
      },
    ],
  },
  {
    text: 'Activity Tracker',
    link: <Timesheet />,
    icon: 'fa fa-calendar-days',
    key: 'user_key',
    url: 'activitytracker',
    file: 'Contents/TimeSheet/timeSheet.js',
    submenu: [
      {
        text: 'Activity Tracker',
        link: <Timesheet />,
        icon: 'fa fa-calendar-days',
        key: 'user_key',
        url: 'activitytracker',
        file: 'Contents/TimeSheet/timeSheet.js',
      },
      {
        text: 'Manage tasks',
        link: <ManageTasks />,
        icon: 'fa fa-cogs',
        key: 'timesheet_managetasks',
        url: 'timesheet_managetasks',
        file: 'Contents/TimeSheet/manageTasks.js',
      },
      {
        text: 'Export',
        link: <ExportComponent />,
        icon: 'fa fa-file',
        key: 'user_key',
        url: 'timesheet_export',
        file: 'Contents/TimeSheet/export.js',
      },
      {
        text: 'Availability Planner',
        link: <AvailabilityPlanner />,
        icon: 'fa-solid fa-calendar-days',
        key: 'user_key',
        url: 'availabilityplanner',
        file: 'Contents/TimeSheet/AvailabilityPlanner/AvailabilityPlannerAdmin.js',
      },
      {
        text: 'Office Calendar',
        link: <OfficeCalendar />,
        icon: 'fa-solid fa-calendar-check',
        key: 'officecalendar_key',
        url: 'officecalendar',
        file: 'Contents/TimeSheet/AvailabilityPlanner/OfficeCalendarAdmin.js',
      },
    ],
  },
  {
    text: 'Vendor Invoicing',
    link: <FreelancerUserAdmin />,
    icon: 'fa-solid fa-receipt',
    key: 'freelancer',
    url: 'freelancer',
    file: 'Contents/FreelancerInvoicing/FreelancerUserAdmin/FreelancerUserAdmin.js',
    submenu: [
      {
        text: 'Vendor - Users',
        linktext: 'Vendors',
        link: <FreelancerUserAdmin />,
        icon: 'fa-solid fa-receipt',
        key: 'freelancer',
        url: 'freelancer',
        file: 'Contents/FreelancerInvoicing/FreelancerUserAdmin/FreelancerUserAdmin.js',
      },
      {
        text: 'Vendor - Fees',
        linktext: 'Fees',
        link: <FreelancerFeeAdmin />,
        icon: 'fa-solid fa-lightbulb-dollar',
        key: 'freelancer',
        url: 'freelancer_freelancerfees',
        file: 'Contents/FreelancerInvoicing/FreelancerFees/FreelancerFeeAdmin.js',
      },
      {
        text: 'Vendor - Line Items',
        linktext: 'Line Items',
        link: <FreelancerLineItemAdmin />,
        icon: 'fa-solid fa-paperclip',
        key: 'freelancer',
        url: 'freelancer_lineitems',
        file: 'Contents/FreelancerInvoicing/FreelancerLineItem/FreelancerLineItemAdmin.js',
      },
      {
        text: 'Vendor - Payable Assignments',
        linktext: 'Payable Assignments',
        link: <FpaAdmin />,
        icon: 'fa-solid fa-socks',
        key: 'freelancerpayableassignment',
        url: 'freelancer_listassignments',
        file: 'Contents/FreelancerInvoicing/FreelancerPayableAssignments/FpaAdmin.js',
      },
      {
        text: 'Vendor - Invoices',
        linktext: 'Invoices',
        link: <FreelancerInvoiceAdmin />,
        icon: 'fa-solid fa-file-invoice-dollar',
        key: 'freelancer',
        url: 'freelancer_invoices',
        file: 'Contents/FreelancerInvoicing/FreelancerInvoices/FreelancerInvoiceAdmin.js',
      },
      {
        text: 'Vendor - Payment Exports',
        linktext: 'Payment Exports',
        link: <FreelancerPaymentExportAdmin />,
        icon: 'fa-solid fa-file-export',
        key: 'freelancer_paymentexports',
        url: 'freelancer_paymentexports',
        file: 'Contents/FreelancerInvoicing/FreelancerPaymentExport/FreelancerPaymentExportAdmin.js',
      },
      {
        text: 'Vendor Dashboard',
        linktext: 'Vendor Dashboard',
        link: <VendorDomoReport />,
        icon: 'fa-solid fa-vial',
        key: 'vendor_dashboard',
        url: 'vendor_dashboard',
        file: 'Contents/FreelancerInvoicing/VendorDashboard/VendorDomoReport.js',
      },
    ],
  },
  {
    text: 'Apollo API JobImport',
    link: <ImportShopAdmin />,
    icon: 'fa-solid fa-shipping-fast',
    key: 'apolloapijobimport',
    url: 'apolloapijobimport',
    file: 'Contents/RoverImport/ImportShopAdmin/ImportShopAdmin.js',
    submenu: [
      {
        text: 'ImportShops',
        linktext: 'ImportShops',
        link: <ImportShopAdmin />,
        icon: 'fa-solid fa-shipping-fast',
        key: 'apolloapijobimport',
        url: 'apolloapijobimport_importshops',
        file: 'Contents/RoverImport/ImportShopAdmin/ImportShopAdmin.js',
      },
      {
        text: 'Apollo Data Export',
        linktext: 'Apollo Data Export',
        link: <ApolloDataExportAdmin />,
        icon: 'fa-solid fa-rocket-launch',
        key: 'JustAdmins',
        url: 'apollo_data_export',
        file: 'Contents/RoverImport/ApolloDataExportAdmin/ApolloDataExportAdmin.js',
      },
      {
        text: 'CaspianXx',
        linktext: 'CaspianXx',
        link: <CaspianXXQueryProcessingHistoryAdmin />,
        icon: 'fa-solid fa-monument',
        key: 'JustAdmins',
        url: 'CaspianXXQueryProcessingHistory',
        file: 'Contents/RoverImport/CaspianXXQueryProcessingHistoryAdmin/CaspianXXQueryProcessingHistoryAdmin.js',
      },
      {
        text: 'Apollo Custom Trigger',
        linktext: 'Apollo Custom Trigger',
        link: <ApolloCustomTriggerAdmin />,
        icon: 'fa-solid fa-shirt',
        key: 'JustAdmins',
        url: 'ApolloCustomTriggerAdmin',
        file: 'Contents/RoverImport/ApolloCustomTriggerAdmin/ApolloCustomTriggerAdmin.js',
      },
      {
        text: 'BambooHR Api Log',
        linktext: 'BambooHR Api Log',
        link: <BambooHrApiLogAdmin />,
        icon: 'fa-solid fa-chopsticks',
        key: 'JustAdmins',
        url: 'BambooHrApiLogAdmin',
        file: 'Contents/LogAdmins/ApiLogAdmin/BambooHrApiLogAdmin.js',
      },
      {
        text: 'Survey Transfer Mapping',
        linktext: 'Survey Transfer Mapping',
        link: <SurveyTransferMappingAdmin />,
        icon: 'fa-solid fa-right-left',
        key: 'surveytransfermapping',
        url: 'SurveyTransferMappingAdmin',
        file: 'Contents/RoverImport/SurveyTransferMappingAdmin/SurveyTransferMappingAdmin.js',
      },
    ],
  },
  {
    text: 'AI Tools',
    link: <AiChatAdmin />,
    icon: 'fa-solid fa-microchip-ai',
    key: 'tools_key',
    url: 'tools',
    file: 'Contents/ToolsMenu/AiChat/AiChatAdmin.jsx',
    submenu: [
      {
        text: 'AI Chat',
        linktext: 'AI Chat',
        link: <AiChatAdmin />,
        icon: 'fa-solid fa-microchip-ai',
        key: 'ai_chat',
        url: 'aichatadmin',
        file: 'Contents/ToolsMenu/AiChat/AiChatAdmin.jsx',
      },
    ],
  },
  {
    text: 'Testing',
    link: <DomoReportTest />,
    icon: 'fa-solid fa-vial',
    key: 'testingkey',
    url: 'test',
    file: 'Contents/Testing/DomoReportTest.js',
    submenu: [
      {
        text: 'Domo Open Shops Report',
        linktext: 'DomoIFrameTest',
        link: <DomoReportTest />,
        icon: 'fa-solid fa-vial',
        key: 'testingkey',
        url: 'domoiframetest',
        file: 'Contents/Testing/DomoReportTest.js',
      },
      {
        text: 'BI Test Reports',
        linktext: 'BI Test Reports',
        link: <BiTestReports />,
        icon: 'fa-solid fa-chart-column',
        key: 'bitestreports',
        url: 'bitestreports',
        file: 'Contents/Testing/BiTestReports.tsx',
      },
    ],
  },
  {
    // Hidden group whose text drives the "ACCOUNT" page-header eyebrow for the account
    // pages (section = active top-level group's text). Kept separate from "Don't show up"
    // so relabelling here doesn't affect the other URL-only routes in that bucket.
    // Members here resolve to the ACCOUNT eyebrow on the F5/deep-link path (content.js);
    // the in-app nav path passes this group object via ProfileMenu's openPage.
    text: 'Account',
    link: <Profile />,
    icon: 'fa-solid fa-user',
    key: 'user_key',
    url: 'profile',
    file: 'Contents/User/UserAdmin/Profile.js',
    shown: false,
    submenu: [
      {
        text: 'Profile',
        link: <Profile />,
        icon: 'fa-solid fa-user',
        key: 'user_key',
        url: 'profile',
        file: 'Contents/User/UserAdmin/Profile.js',
      },
      {
        text: 'Messages',
        link: <Messages />,
        icon: 'fa-regular fa-envelope',
        key: 'user_key',
        url: 'messages',
        file: 'Contents/Messages/Messages.js',
      },
      {
        text: 'Downloads',
        link: <Downloads />,
        icon: 'fa-solid fa-download',
        key: 'user_key',
        url: 'downloads',
        file: 'Contents/Downloads/Downloads.js',
      },
    ],
  },
  {
    text: "Don't show up",
    link: <TestComponentForUrlBasedPages />,
    icon: 'fa-solid fa-angel',
    key: 'user_key',
    url: 'godtest',
    file: 'Elements/TestComponentForUrlBasedPages.js',
    shown: false,
    submenu: [
      //Here you can store the components which should be accessible via url but musn't be shown in the menu.
      // Give each real page a `section: '<top-level group text>'` so the page-header eyebrow reads
      // its true section instead of this bucket's text. (`reports_*` urls resolve to 'Reports'
      // automatically — see redux/selectors.js.)
      {
        text: 'Test for url based pages',
        linktext: 'Test for url based pages',
        link: <TestComponentForUrlBasedPages />,
        icon: 'fa-solid fa-book',
        key: 'user_key',
        url: 'testforurlbasedpages',
        file: 'Elements/TestComponentForUrlBasedPages.js',
      },
      {
        text: 'Payment Export Details',
        linktext: 'Payment Export Details',
        // Eyebrow override: URL-only page in the hidden "Don't show up" bucket; the
        // page-header eyebrow should read its real section (Operations), not the bucket text.
        section: 'Operations',
        link: <PaymentExportDetails />,
        icon: 'fa-solid fa-book',
        key: 'user_key',
        url: 'paymentexportdetails',
        file: 'Contents/Operations/PaymentExport/AllExport/PaymentExportDetails.js',
      },
      {
        text: 'Planning - Planning items',
        section: 'Operations',
        link: <PlanningList />,
        icon: 'fa-regular fa-address-book',
        key: 'user_key',
        url: 'planning_planningList',
        file: 'Contents/Planning/PlanningItem/PlanningList.js',
      },
      {
        text: 'Planning Detail List',
        section: 'Operations',
        link: <PlanningDetailList />,
        icon: 'fa-regular fa-address-book',
        key: 'user_key',
        url: 'planning_PlanningDetailList',
        file: 'Contents/Planning/PlanningDetail/PlanningDetailList.js',
      },
      {
        text: 'Ref Example',
        link: <RefExample />,
        icon: 'fa-regular fa-address-book',
        key: 'user_key',
        url: 'RefExample',
        file: 'Experiment/RefExample/RefExample.js',
      },
      {
        text: 'Client Line Details',
        linktext: 'Client Line Details',
        section: 'Operations',
        link: <ClientLineItemDetails />,
        icon: 'fa-solid fa-book',
        key: 'user_key',
        url: 'clientlineitemdetails',
        file: 'Contents/Operations/CreditMemo/ClientLineItemDetails.js',
      },
      {
        text: TpClientInvoiceLineItemDetails.getMenuText(),
        linktext: 'Third-Party Client Line Details',
        section: 'TP Operations',
        link: <TpClientInvoiceLineItemDetails />,
        icon: 'fa-solid fa-book',
        key: 'user_key',
        url: 'tpclientinvoicelineitemdetails',
        file: 'Contents/Operations/TpCreditMemo/Details/TpClientInvoiceLineItemDetails.js',
      },
      {
        text: 'IOB Details',
        linktext: 'IOB Details',
        section: 'Operations',
        link: <IobDetails />,
        icon: 'fa-solid fa-book',
        key: 'user_key',
        url: 'iobdetails',
        file: 'Contents/Operations/IOB/IobDetails.js',
      },
      {
        text: 'Survey Transfer Question Mapping',
        linktext: 'Survey Transfer Question Mapping',
        section: 'Apollo API JobImport',
        link: <SurveyTransferQuestionRulesDetails />,
        icon: 'fa-solid fa-book',
        key: 'surveytransfermapping',
        url: 'surveytransferquestionrulesdetails',
        file: 'Contents/RoverImport/SurveyTransferMappingAdmin/SurveyTransferQuestionRulesDetails.tsx',
      },
      {
        text: 'Survey Transfer Answer Option Mapping',
        linktext: 'Survey Transfer Answer Option Mapping',
        section: 'Apollo API JobImport',
        link: <SurveyTransferAnswerOptionRulesDetails />,
        icon: 'fa-solid fa-book',
        key: 'surveytransfermapping',
        url: 'surveytransferansweroptionrulesdetails',
        file: 'Contents/RoverImport/SurveyTransferMappingAdmin/SurveyTransferAnswerOptionRulesDetails.tsx',
      },
      {
        text: 'Pricing Detail',
        // Eyebrow override: this URL-only page lives in the hidden "Don't show up" bucket,
        // but the page-header eyebrow should read its real section (Sales), not the bucket text.
        section: 'Sales',
        link: <PricingDetailAdmin />,
        icon: 'fa-solid fa-book',
        key: 'user_key',
        url: 'sales_PricingDetailList',
        file: 'Contents/Sales/PricingDetail/PricingDetailAdmin.jsx',
      },
      {
        text: 'Pricing',
        section: 'Sales',
        link: <PricingAdmin />,
        icon: 'fa-regular fa-address-book',
        key: 'user_key',
        url: 'sales_pricing',
        file: 'Contents/Sales/PricingAdmin/PricingAdmin.jsx',
      },
      {
        text: 'Credit Memo Details',
        linktext: 'Credit Memo Details',
        section: 'Operations',
        link: <CreditMemoDetails />,
        icon: 'fa-solid fa-book',
        key: 'user_key',
        url: 'creditmemodetails',
        file: 'Contents/Operations/CreditMemo/CreditMemoDetails.js',
      },
      {
        text: 'Credit Memo Request Details',
        linktext: 'Credit Memo Request Details',
        section: 'Operations',
        link: <CreditMemoRequestDetails />,
        icon: 'fa-solid fa-book',
        key: 'user_key',
        url: 'creditmemorequestdetails',
        file: 'Contents/Operations/CreditMemo/CreditMemoRequestDetails.js',
      },
      {
        text: TpCreditMemoDetails.getMenuText(),
        linktext: 'Third-Party Credit Memo Details',
        section: 'TP Operations',
        link: <TpCreditMemoDetails />,
        icon: 'fa-solid fa-book',
        key: 'user_key',
        url: 'tpcreditmemodetails',
        file: 'Contents/Operations/TpCreditMemo/Details/TpCreditMemoDetails.js',
      },
      {
        text: ClientInvoiceDetails.getMenuText(),
        linktext: 'Client Invoice Details',
        // Eyebrow override: URL-only page in the hidden "Don't show up" bucket; the
        // page-header eyebrow should read its real section (Operations), not the bucket text.
        section: 'Operations',
        link: <ClientInvoiceDetails />,
        icon: 'fa-solid fa-book',
        key: 'user_key',
        url: 'clientinvoicedetails',
        file: 'Contents/Operations/ClientInvoiceAdmin/Details/ClientInvoiceDetails.js',
      },
      {
        text: TpClientInvoiceDetails.getMenuText(),
        linktext: 'Third-Party Client Invoice Details',
        section: 'TP Operations',
        link: <TpClientInvoiceDetails />,
        icon: 'fa-solid fa-book',
        key: 'user_key',
        url: 'tpclientinvoicedetails',
        file: 'Contents/Operations/TpClientInvoice/Details/TpClientInvoiceDetails.js',
      },
      {
        text: 'Assignment Payment Details',
        linktext: 'Assignment Payment Details',
        section: 'Operations',
        link: <AssignmentPaymentDetails />,
        icon: 'fa-solid fa-book',
        key: 'user_key',
        url: 'paymentdetails',
        file: 'Contents/Evaluator/EvaluatorAdmin/EvaluatorPayments/AssignmentPaymentDetails.js',
      },
      {
        text: 'Service',
        linktext: 'Service',
        section: 'Sales',
        link: <ServiceDetails />,
        icon: 'fa-solid fa-book',
        url: 'servicedetails',
        key: 'user_key',
        file: 'Contents/Sales/ServiceAdmin/ServiceDetails.js',
      },
      {
        text: 'Pricing',
        linktext: 'Pricing Item Details',
        section: 'Sales',
        link: <PricingItemDetails />,
        icon: 'fa-solid fa-book',
        url: 'pricingitemdetails',
        key: 'user_key',
        file: 'Contents/Sales/PricingAdmin/PricingItemDetails.js',
      },
      {
        text: FraudHitDetails.getMenuText(),
        linktext: 'Fraud Hit Details',
        // Eyebrow override: URL-only page in the hidden "Don't show up" bucket; the
        // page-header eyebrow should read its real section (Operations), not the bucket text.
        section: 'Operations',
        link: <FraudHitDetails />,
        icon: 'fa-solid fa-book',
        key: 'user_key',
        url: 'fraudhitdetails',
        file: 'Contents/Operations/AntiFraudTool/FraudHitDetails.js',
      },
      {
        text: ClientPaymentDetails.getMenuText(),
        linktext: 'Client Payment Details',
        section: 'Finance',
        link: <ClientPaymentDetails />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'clientpaymentdetails',
        file: 'Contents/Finance/ClientPayment/ClientPaymentDetails.js',
      },
      {
        text: TpClientPaymentDetails.getMenuText(),
        linktext: 'Client Payment Details',
        section: 'Finance',
        link: <TpClientPaymentDetails />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'new_clientpaymentdetails',
        file: 'Contents/ThirdParty/TpClientPayment/TpClientPaymentDetails.js',
      },
      {
        text: ClientPrePaymentDetails.getMenuText(),
        linktext: 'Prepayment Details',
        section: 'Finance',
        link: <ClientPrePaymentDetails />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'clientprepaymentdetails',
        file: 'Contents/Finance/ClientPrePayment/ClientPrePaymentDetails.js',
      },
      {
        text: TpRealtedClientPrePaymentDetails.getMenuText(),
        linktext: 'Prepayment Details',
        section: 'Finance',
        link: <TpRealtedClientPrePaymentDetails />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'tprelatedclientprepaymentdetails',
        file: 'Contents/ThirdParty/TpClientPayment/ClientPrePayment/TpRealtedClientPrePaymentDetails.js',
      },
      {
        text: TpClientPrePaymentDetails.getMenuText(),
        linktext: 'Prepayment Details',
        section: 'Finance',
        link: <TpClientPrePaymentDetails />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'tpclientprepaymentdetails',
        file: 'Contents/ThirdParty/TpClientPayment/ClientPrePayment/TpClientPrePaymentDetails.js',
      },
      {
        text: 'Unbilled AR',
        linktext: 'Unbilled AR',
        link: <UnbilledAR />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_unbilledar',
        file: 'Elements/Reports/GeneralFinanceReports/UnbilledAR.js',
      },
      {
        text: 'Assignment Details Lite',
        linktext: 'Assignment Details Lite',
        link: <AssignmentDetailsLite />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_assignmentdetailslite',
        file: 'Elements/Reports/GeneralFinanceReports/AssignmentDetailsLite.js',
      },
      {
        text: 'Client Assignment R. & E. Sum.',
        linktext: 'Client Assignment Revenue and Expenses Summary',
        link: <ClientAssignmentRevenueExpenses />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_clientassignmentrevenueexpenses',
        file: 'Elements/Reports/GeneralFinanceReports/ClientAssignmentRevenueExpenses.js',
      },
      {
        text: 'Project Assignment R. & E. Sum.',
        linktext: 'Project Assignment Revenue and Expenses Summary',
        link: <ProjectAssignmentRevenueExpenses />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_projectassignmentrevenueexpenses',
        file: 'Elements/Reports/GeneralFinanceReports/ProjectAssignmentRevenueExpenses.js',
      },
      {
        text: 'Void and Reissued',
        linktext: 'Void and Reissued',
        link: <VoidAndReissued />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_voidandreissued',
        file: 'Elements/Reports/GeneralFinanceReports/VoidAndReissued.js',
      },
      {
        text: 'Operational Subledger Detail',
        linktext: 'Operational Subledger Detail',
        link: <OperationalSubledgerDetail />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_operationalsubledgerdetail',
        file: 'Elements/Reports/GeneralFinanceReports/OperationalSubledgerDetail.js',
      },
      {
        text: 'Operational Subledger Summary',
        linktext: 'Operational Subledger Summary',
        link: <OperationalSubledgerSummary />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_operationalsubledgersummary',
        file: 'Elements/Reports/GeneralFinanceReports/OperationalSubledgerSummary.js',
      },
      {
        text: 'Client Deposit Details',
        linktext: 'Client Deposit Details',
        link: <ClientDepositDetails />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_clientdepositdetails',
        file: 'Elements/Reports/GeneralFinanceReports/ClientDepositDetail.js',
      },
      {
        text: 'Prepay Line Items AR',
        linktext: 'Prepay Line Items AR',
        link: <PrepayLineItemsAR />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_prepaylineitemsar',
        file: 'Elements/Reports/GeneralFinanceReports/PrepayLineItemsAr.js',
      },
      {
        text: 'Line Items AR',
        linktext: 'Line Items AR',
        link: <LineItemsAr />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_lineitemsar',
        file: 'Elements/Reports/GeneralFinanceReports/LineItemsAr.js',
      },
      {
        text: 'Credit Memos AR',
        linktext: 'Credit Memos AR',
        link: <CreditMemosAr />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_creditmemosar',
        file: 'Elements/Reports/GeneralFinanceReports/CreditMemosAr.js',
      },
      {
        text: 'Prepay Credit Memos AR',
        linktext: 'Prepay Credit Memos AR',
        link: <PrepayCreditMemosAr />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_prepaycreditmemosar',
        file: 'Elements/Reports/GeneralFinanceReports/PrepayCreditMemosAr.js',
      },
      {
        text: 'IOB List',
        linktext: 'IOB List',
        link: <IobList />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_ioblist',
        file: 'Elements/Reports/GeneralFinanceReports/IobList.js',
      },
      {
        text: 'Client Adjusted Gross Revenue',
        linktext: 'Client Adjusted Gross Revenue - BETA',
        link: <ClientAdjustedGrossRevenue />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_clientadjustedgrossrevenue',
        file: 'Elements/Reports/GeneralFinanceReports/ClientAdjustedGrossRevenue.js',
      },
      {
        text: 'IOB Summary',
        linktext: 'IOB Summary',
        link: <IobSummary />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_iobsummary',
        file: 'Elements/Reports/CorporateOfficeFinanceReports/IobSummary.js',
      },
      {
        text: 'Tax Report',
        linktext: '1099 Report',
        link: <TaxReport />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_taxreport',
        file: 'Elements/Reports/CorporateOfficeFinanceReports/TaxReport.js',
      },
      {
        text: 'Evaluator Payment Rec Report',
        linktext: 'Evaluator Payment Rec Report',
        link: <EvaluatorPaymentRecReport />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_evaluatorpaymentrec',
        file: 'Elements/Reports/CorporateOfficeFinanceReports/EvaluatorPaymentRecReport.js',
      },
      {
        text: 'Office Gross Profit',
        linktext: 'Office Gross Profit',
        link: <OfficeGrossProfitReport />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_officegrossprofitreport',
        file: 'Elements/Reports/GeneralFinanceReports/OfficeGrossProfitReport.js',
      },
      {
        text: 'Journal Entries',
        linktext: 'Journal Entries',
        link: <JournalEntriesReport />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_journalentriesreport',
        file: 'Elements/Reports/GeneralFinanceReports/JournalEntriesReport.js',
      },
      {
        text: 'Evaluator Expense Analysis',
        linktext: 'Evaluator Expense Analysis',
        link: <EvaluatorExpenseAnalysisReport />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_evaluatorexpenseanalysisreport',
        file: 'Elements/Reports/GeneralFinanceReports/EvaluatorExpensesAnalysisReport.js',
      },
      {
        text: 'Assignment Details Report',
        linktext: 'Assignment Details',
        link: <AssignmentDetails />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_assignmentdetails',
        file: 'Elements/Reports/GeneralFinanceReports/AssignmentDetails.js',
      },
      {
        text: 'Third-Party Assignment Details Report',
        linktext: 'Third-Party Assignment Details',
        link: <TpAssignmentDetails />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_tpassignmentdetails',
        file: 'Elements/Reports/GeneralFinanceReports/TpAssignmentDetails.js',
      },
      {
        text: 'Assgn. Fee Revenue by Industry',
        linktext: 'Assignment Fee Revenue by Industry',
        link: <AssignmentFeeRevenueByIndustry />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_assignmentfeerevenuebyindustry',
        file: 'Elements/Reports/RevenueMetricsReports/AssignmentFeeRevenueByIndustry.js',
      },
      {
        text: 'Assgn. Fee Revenue by Service',
        linktext: 'Assignment Fee Revenue by Service',
        link: <AssignmentFeeRevenueByService />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_assignmentfeerevenuebyservice',
        file: 'Elements/Reports/RevenueMetricsReports/AssignmentFeeRevenueByService.js',
      },
      {
        text: 'Line Item Fee Revenue by Industry',
        linktext: 'Line Item Fee Revenue by Industry',
        link: <LineItemFeeRevenueByIndustry />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_lineitemfeerevenuebyindustry',
        file: 'Elements/Reports/RevenueMetricsReports/LineItemFeeRevenueByIndustry.js',
      },
      {
        text: 'Line Item Fee Revenue by Type',
        linktext: 'Line Item Fee Revenue by Type',
        link: <LineItemFeeRevenueByType />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_lineitemfeerevenuebytype',
        file: 'Elements/Reports/RevenueMetricsReports/LineItemFeeRevenueByType.js',
      },
      {
        text: 'Assgn. + Ln. I. Fee Revenue by Ind.',
        linktext: 'Assignments + Line Items Fee Revenue by Industry',
        link: <AssignmentLineItemFeeRevenueByIndustry />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_assignmentslineitemsfeerevenuebyindustry',
        file: 'Elements/Reports/RevenueMetricsReports/AssignmentLineItemFeeRevenueByIndustry.js',
      },
      {
        text: 'AR Ageing Report',
        linktext: 'AR Ageing Report',
        link: <ArAgeingReport />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_arageingreport',
        file: 'Elements/Reports/IFrameReports/ArAgeingReport.js',
      },
      {
        text: 'Shop Count Report',
        linktext: 'Shop Count Report',
        link: <ShopCountReport />,
        icon: 'fa-solid fa-file-chart-column',
        key: 'user_key',
        url: 'reports_shopcountreport',
        file: 'Elements/Reports/IFrameReports/ShopCountReport.js',
      },
      {
        text: 'Ops PBI Dashboard',
        linktext: 'Ops PBI Dashboard',
        link: <OpsPBIDashboard />,
        icon: 'fa-solid fa-money-bill-wave',
        key: 'user_key',
        url: 'reports_opspbidashboard',
        file: 'Elements/Reports/IFrameReports/OpsPBIDashboard.js',
      },
      {
        text: 'DQ TAT Report',
        linktext: 'DQ TAT Report',
        link: <DqTatReport />,
        icon: 'fa-solid fa-file-chart-column',
        key: 'user_key',
        url: 'reports_dqtatreport',
        file: 'Elements/Reports/IFrameReports/DqTatReport.tsx',
      },
    ],
  }, ];

export default menuitems;
